import { jsx as _jsx } from "react/jsx-runtime";
export const Menu = ({ children }) => {
    return _jsx("aside", { className: "menu", children: children });
};
Menu.displayName = 'Menu';
Menu.Label = ({ children }) => {
    return _jsx("p", { className: "menu-label", children: children });
};
Menu.Label.displayName = 'Menu.Label';
Menu.List = ({ children }) => {
    return _jsx("ul", { className: "menu-list", children: children });
};
Menu.List.displayName = 'Menu.List';
Menu.Item = ({ children }) => {
    return _jsx("li", { children: children });
};
Menu.Item.displayName = 'Menu.Item';
//# sourceMappingURL=Menu.js.map